import { render, staticRenderFns } from "./retailerWhitelistComponent.vue?vue&type=template&id=0fed4685&"
import script from "./retailerWhitelistComponent.vue?vue&type=script&lang=js&"
export * from "./retailerWhitelistComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports